import $apiPrivate from '@/api/apiPrivate';

const sendGAClientId = async params => {
  const response = await $apiPrivate.post('clients/analytics/context', params);
  return response;
};

export default {
  sendGAClientId,
};
